.container {
  align-self: stretch;
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.headerAndDescription {
  align-self: stretch;
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
